import { t } from 'i18next'
import React from 'react'
import { Link } from 'widgets-for-react'
import { ExternalLink } from '../utils/external_link'
import { addLangToUrl, getLangFromHost, getLangFromUrl, updateUrlLang } from '../utils/history.mod'
import { FooterState } from './state'

export const FooterLayout = ({
  menu,
  privacyMenu,
  refrescoBranding
}: FooterState & { refrescoBranding: boolean }): JSX.Element => {
  const lang = getLangFromUrl()
  const isNA = lang == 'na' || lang == 'na-fr' || lang == 'na-es'

  const currentCountry = getLangFromHost()

  return refrescoBranding ? (
    <FooterAux>
      <div className="footer__inner container container--m grid--gutter"></div>
    </FooterAux>
  ) : (
    <FooterAux>
      <div className="footer__inner container container--m grid--gutter">
        <div className="footer__logo">
          <Link to={addLangToUrl('/')}>
            <img src="/images/logo-new-refresco.svg" alt="Refresco logo" width="200" height="33" />
          </Link>
        </div>
        <nav className="nav nav--footer">
          {/* Quicklinks */}
          {menu.kind == 'loaded' && (
            <ul className="nav__list" id="a11y-footer-navigation">
              {menu.value
                .map((menuItem) => (
                  <li className="nav__item">
                    {menuItem.url && (
                      <ExternalLink
                        type="link"
                        className="nav__link"
                        to={
                          menuItem.url?.startsWith('http') || menuItem.url?.startsWith('www')
                            ? menuItem.url
                            : updateUrlLang(menuItem.url, lang)
                        }
                      >
                        {menuItem.label}
                      </ExternalLink>
                    )}
                  </li>
                ))
                .toArray()}
            </ul>
          )}
        </nav>
      </div>

      <div className="footer__bottom container container--m grid--gutter">
        <div className="footer__copyright" id="a11y-footer-copyright">
          <span>
            {isNA
              ? '® Refresco North America 2026'
              : lang == 'uk'
              ? '® Refresco United Kingdom 2026'
              : currentCountry == 'au'
              ? '® Refresco Australia 2026'
              : t('footer:copyright')}
          </span>
          <div className="footer__social">
            <a
              className="footer__social-link footer__social-link--linkedin"
              href="https://www.linkedin.com/company/refresco/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            />
            {socialMediaLink('na', 'facebook', 'https://www.facebook.com/RefrescoUSCareers')}
            {socialMediaLink('na', 'instagram', 'https://www.instagram.com/refresconorthamerica')}
            {socialMediaLink('global', 'instagram', 'https://www.instagram.com/refrescogroup')}
            {socialMediaLink('nl', 'facebook', 'https://www.facebook.com/RefrescoBenelux')}
            {socialMediaLink('fr', 'facebook', 'https://www.facebook.com/RefrescoFrance')}
            {socialMediaLink('fr', 'instagram', 'https://www.instagram.com/refresco_france')}
            {socialMediaLink('au', 'facebook', 'https://www.facebook.com/RefrescoAustralia')}
            {socialMediaLink('au', 'instagram', 'https://www.instagram.com/refrescoaustralia')}
          </div>
        </div>
      </div>
    </FooterAux>
  )
}

type FooterComponentState = {}

class FooterAux extends React.Component<{ children: React.ReactNode }, FooterComponentState> {
  private raf: number
  private footerRef: HTMLElement
  private scrollStartTime = 0
  private scrollStartY = 0

  constructor(props) {
    super(props)

    this.state = {
      sticky: false,
      shown: false
    }
  }

  render() {
    const classes: Array<string> = ['footer']

    return (
      <footer id="a11y-footer" className={classes.join(' ')}>
        {this.props.children}
      </footer>
    )
  }
}

const socialMediaLink = (lang: string, socialName: string, url: string) => {
  if (getLangFromHost() == lang) {
    return (
      <a
        className={`footer__social-link footer__social-link--${socialName}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={socialName.charAt(0).toUpperCase() + socialName.slice(1)}
      />
    )
  }
}
